<template>
  <div id="wallet">
    <el-form :inline="true">
      <el-form-item label="服务月份">
        <el-date-picker v-model="month" type="month" placeholder="选择月" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="tabs">
      <el-row :gutter="20">
        <el-col :span="14">
          <div class="panel">
            <div class="panel-head">
              <h4>预估报酬</h4>
            </div>
            <div class="left-con">
            <div>
              <p class="big">￥{{ totalAmount ? totalAmount : 0 }}</p><p>报酬总额</p>
            </div>
            <div class="fuhao">
              <p>=</p><p></p>
            </div>
            <div>
              <p class="big">￥{{ basicSalaryAmount ? basicSalaryAmount : 0 }}</p><p>任务报酬</p>
            </div>
            <div class="fuhao">
              <p>+</p><p></p>
            </div>
            <div>
              <p class="big">￥{{ serviceAwardAmount ? serviceAwardAmount : 0 }}</p><p>奖励</p>
            </div>
            <div class="fuhao">
              <p>-</p><p></p>
            </div>
            <div>
              <p class="big">￥{{ servicePunishAmount ? servicePunishAmount : 0 }}</p><p>扣罚</p>
            </div>
          </div>
          </div>
        </el-col>
        <el-col :span="10">
          <div class="panel">
            <div class="panel-head">
              <h4>实际发放</h4>
            </div>
            <div class="right-con">
              <div>
                <p class="big">￥{{ paySuccessAmount ? paySuccessAmount : 0 }}</p><p>实发</p>
              </div>
              <div>
                <p class="big">￥{{ tax ? tax : 0 }}</p><p>扣税</p>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-table :data="salaryList" border highlight-current-row style="width: 100%">
        <el-table-column prop="serviceDate" label="日期" align="center"></el-table-column>
        <el-table-column prop="serviceShop" label="服务店铺" align="center"></el-table-column>
        <el-table-column prop="amount" label="金额" align="center">
          <template slot-scope="scope">
            ￥{{ scope.row.amount }}
          </template>
        </el-table-column>
        <el-table-column prop="amountExpression" label="说明" align="center"></el-table-column>
      </el-table>
    </div>
	</div>
</template>

<script>
export default {
  data() {
    return {
      month: this.getCurrentDate().monthStartDate,
      salaryList: [],
      totalAmount: '', //报酬总额
      basicSalaryAmount: '', //任务报酬
      serviceAwardAmount: '', //奖励
      servicePunishAmount: '', //扣罚
      paySuccessAmount: '', //实发
      tax: '', //扣税
    }
  },
  mounted() {
    this.getSearch();
  },
  methods: {
    dateFormatString (date, format) { // 时间格式化
      var date = new Date(date),
          o = {
            "M+" : date.getMonth() + 1,
            "d+" : date.getDate(),
            "h+" : date.getHours(),
            "m+" : date.getMinutes(),
            "s+" : date.getSeconds(),
            "q+" : Math.floor((date.getMonth() + 3) / 3),
            "S" : date.getMilliseconds()
          };
      
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    getCurrentDate() {
      let now = new Date(); //当前日期
      let nowDayOfWeek = now.getDay(); //今天本周的第几天
      let nowDay = now.getDate(); //当前日
      let nowMonth = now.getMonth(); //当前月
      let nowYear = now.getYear(); //当前年
      nowYear += (nowYear < 2000) ? 1900 : 0; 
      let lastMonthDate = new Date(); //上月日期 
      lastMonthDate.setDate(1); 
      lastMonthDate.setMonth(lastMonthDate.getMonth()-1); 
      let lastYear = lastMonthDate.getYear(); 
      let lastMonth = lastMonthDate.getMonth();
      return {
        monthStartDate: this.getMonthStartDate(nowYear, nowMonth)
      }
    },
    //获得本月的开端日期
    getMonthStartDate(nowYear, nowMonth){
      var monthStartDate = new Date(nowYear, nowMonth, 1);
      return this.dateFormatString(monthStartDate, 'yyyy-MM-dd hh:mm:ss');
    },
    getSearch() {
      this.getMoney();
      this.getList();
    },
    getMoney() {
      var data = {
        month: this.month,
        accumulated: false
      }
      this.$http.post(API_ROOT.tjkInfo + '/wallet/getHistorySalaryTotalAmountDetail', data).then(response=> {
        var result = response.data
        if(result.success) {
          this.totalAmount = result.data.totalAmount;
          this.basicSalaryAmount = result.data.basicSalaryAmount;
          this.serviceAwardAmount = result.data.serviceAwardAmount;
          this.servicePunishAmount = result.data.servicePunishAmount;
          this.paySuccessAmount = result.data.paySuccessAmount;
          this.tax = result.data.tax;
        }else {
          this.$alert(result.msg)
        }
      },response=> {
        this.$alert("网络繁忙，请稍后重试！")
      })
    },
    getList() {
      var data = {
        month: this.month,
        salaryType: 'ALL'
      }
      this.$http.post(API_ROOT.tjkInfo + '/wallet/querySalaryRecordDetailList', data).then(response=> {
        var result = response.data
        if(result.success) {
          this.salaryList = result.data;
        }else {
          this.$alert(result.msg)
        }
      },response=> {
        this.$alert("网络繁忙，请稍后重试！")
      })
    }
  }
}
</script>

<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// ./src/page/customerIframe/wallet.vue